import { Dispatch } from 'redux';

import Analytics from '@hh.ru/analytics-js';

import { ExperimentsState } from '../../../types';
import { camelToSnakeCase } from '../../../utils/notationConverter';
import { getServiceName } from '../serviceName';
import { InitialExperimentsState, addCheckedExp } from './store';

export const CONTROL_GROUP = 'control';
export const EXPERIMENT_GROUP = 'experiment';
export const NOT_IN_EXPERIMENT_GROUP = 'not_in_experiment';

interface SendExperimentCheckAnalyticsParams {
    exps: InitialExperimentsState;
    experimentName: string;
    experimentGroup: string;
    dispatch: Dispatch;
}

const sendExperimentCheckAnalytics = ({
    exps,
    experimentName,
    experimentGroup,
    dispatch,
}: SendExperimentCheckAnalyticsParams) => {
    if (!exps.checked.includes(experimentName)) {
        if (!process.env.SSR) {
            Analytics.sendHHEvent('user_in_experiment_check', {
                source: camelToSnakeCase(getServiceName()),
                [experimentGroup]: experimentName,
            });
        }
        dispatch(addCheckedExp(experimentName));
    }
};

export function experimentGroupCheckFunction(
    exps: ExperimentsState,
    experimentName: string,
    dispatch: Dispatch,
    sendCheck = true
): string {
    const experimentGroup = (exps as InitialExperimentsState).enabled[experimentName] || NOT_IN_EXPERIMENT_GROUP;
    if (sendCheck) {
        sendExperimentCheckAnalytics({
            exps: exps as InitialExperimentsState,
            experimentName,
            experimentGroup,
            dispatch,
        });
    }
    return experimentGroup;
}

// Функцию можно использовать отдельно от useExperimentCheckFunction, чтобы проверять вхождение в эксперимент
// не в React компоненте. Например, можно использовать в Redux Thunk
export default function experimentCheckFunction(
    exps: ExperimentsState,
    experimentName: string,
    dispatch: Dispatch,
    sendCheck = true
): boolean {
    return experimentGroupCheckFunction(exps, experimentName, dispatch, sendCheck) === EXPERIMENT_GROUP;
}

export function experimentControlCheckFunction(
    exps: ExperimentsState,
    experimentName: string,
    dispatch: Dispatch,
    sendCheck = true
): boolean {
    return experimentGroupCheckFunction(exps, experimentName, dispatch, sendCheck) === CONTROL_GROUP;
}
